import React from "react";

import { HttpMetricsTimelineData } from "Api/observability/pipeline/types";
import todayOrYesterday from "Libs/datetime";
import Tooltip from "src/organization/pages/project/environment/metrics/components/tooltip";
import {
  Flex,
  Table,
  TableRow,
  Td
} from "src/organization/pages/project/environment/metrics/components/tooltip/style";
import RoundLegend from "src/organization/pages/project/environment/metrics/http2/components/RoundLegend";
import { formatNumber } from "src/organization/pages/project/environment/metrics/http2/helper/index";
import { DateTime } from "src/organization/pages/project/environment/metrics/http2/impact/style";
import { TopImpactValueType } from "src/organization/pages/project/environment/metrics/http2/impact/types";
import { CursorDataSyncType } from "src/organization/pages/project/environment/metrics/http2/types";

import { sortMetricsByImpact } from "./util";

type ImpactTooltipProps = {
  cursorSync?: CursorDataSyncType<HttpMetricsTimelineData>;
  series: TopImpactValueType[][];
};

const ImpactTooltip = (props: ImpactTooltipProps) => {
  const { chartRect, adaptedCursor } = props.cursorSync || {};
  const {
    absoluteY,
    absoluteX,
    dataIndex,
    activityId,
    tooltipIsPositionable,
    indexedData
  } = adaptedCursor || {};

  // Get HttpMetrics for each impact series that currespond to the cursor index
  const indexedSeries =
    dataIndex !== undefined
      ? props.series
          .map(impact => ({ ...impact[dataIndex] }))
          .sort(sortMetricsByImpact)
      : [];

  const date = indexedData?.date;

  return (
    <Tooltip
      chartRect={chartRect}
      isVisible={tooltipIsPositionable}
      x={absoluteX}
      y={absoluteY}
      activityId={activityId}
    >
      <Table>
        <tbody>
          <TableRow>
            <DateTime colSpan={3}>
              {date ? todayOrYesterday(date) : ""}
            </DateTime>
          </TableRow>
          {indexedSeries.map((d, index) =>
            d.url ? (
              <TableRow key={`${d.date}-${index}`}>
                <Td>
                  <Flex>
                    <RoundLegend color={d.color} />
                    <span className="bold">{d.impact.toFixed(1) || 0}%</span>
                  </Flex>
                </Td>
                <Td setMinWidth={false}>
                  {formatNumber({
                    value: d.value
                  })}
                </Td>
                <Td setMinWidth={false}>{d.method}</Td>
                <Td>{d.url}</Td>
              </TableRow>
            ) : null
          )}
        </tbody>
      </Table>
    </Tooltip>
  );
};

export default ImpactTooltip;
